import * as Parser from "../Parser";
import * as Platform from "../Platform";
import * as Serializer from "../Serializer";
import { Socket } from "../Socket";
import { Header as ResponseHeader } from "./Header";
import { Like as ResponseLike } from "./Like";
export var Response;
(function (Response) {
    function is(value) {
        return (typeof value == "object" &&
            Object.keys(value).every(key => ["status", "header", "body", "socket"].some(k => k == key)) &&
            (value.status == undefined || typeof value.status == "number") &&
            (value.header == undefined || ResponseHeader.is(value.header)) &&
            (value.socket == undefined || value.socket instanceof WebSocket));
    }
    Response.is = is;
    async function to(request) {
        return new Platform.Response(await Serializer.serialize(await request.body, request.header.contentType), {
            status: request.status,
            headers: new Headers(ResponseHeader.to(!request.header.contentType?.startsWith("multipart/formdata")
                ? request.header
                : (({ contentType, ...header }) => header)(request.header))),
            ...(request.socket && {
                webSocket: { ...request.socket.createResponse().socket }?.backend,
            }),
        });
    }
    Response.to = to;
    function from(response) {
        return {
            status: response.status,
            header: ResponseHeader.from(response.headers),
            body: response.status == 101 ? undefined : Parser.parse(response),
            ...(response.webSocket && { socket: new Socket.Factory(response.webSocket) }),
        };
    }
    Response.from = from;
    function create(response, contentType) {
        const result = ResponseLike.is(response)
            ? {
                status: 200,
                header: {},
                body: undefined,
                ...(response.socket && { socket: response.socket }),
                ...response,
            }
            : typeof response?.createResponse == "function" && (contentType == undefined || ResponseHeader.is(contentType))
                ? response.createResponse(contentType)
                : {
                    status: (typeof response == "object" && typeof response.status == "number" && response.status) || 200,
                    header: typeof response == "object"
                        ? {
                            ...response.header,
                            ...((response.status == 301 || response.status == 302) && response.location
                                ? { location: response.location }
                                : {}),
                        }
                        : {},
                    body: !(typeof response == "object" && !Array.isArray(response)) ||
                        response instanceof ArrayBuffer ||
                        ArrayBuffer.isView(response) ||
                        response instanceof FormData
                        ? response
                        : (({ header, ...body }) => body)(response),
                    ...((response.webSocket && { socket: new Socket.Factory(response.webSocket) }) ||
                        (response.socket && { socket: response.socket })),
                };
        if (!result.header.contentType)
            switch (typeof result.body) {
                case "undefined":
                    break;
                default:
                case "object":
                    result.header.contentType =
                        typeof contentType == "string"
                            ? contentType
                            : contentType?.contentType
                                ? contentType.contentType
                                : result.body instanceof FormData
                                    ? "multipart/formdata"
                                    : result.body instanceof ArrayBuffer || ArrayBuffer.isView(result.body)
                                        ? isPdf(result.body)
                                            ? "application/pdf"
                                            : "application/octet-stream"
                                        : "application/json; charset=utf-8";
                    break;
                case "string":
                    result.header.contentType =
                        result.body.slice(0, 9).toLowerCase() == "<!doctype"
                            ? "text/html; charset=utf-8"
                            : /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/.test(result.body)
                                ? "application/jwt; charset=utf-8"
                                : /^<\?xml version=(.|\n)*\?>(.|\n)*<svg(.|\n)*<\/svg>$/.test(result.body)
                                    ? "image/svg+xml"
                                    : "text/plain; charset=utf-8";
                    break;
            }
        return result;
    }
    Response.create = create;
    function isPdf(body) {
        const bytes = new Uint8Array(ArrayBuffer.isView(body) ? body.buffer : body).slice(0, 4);
        return [37, 80, 68, 70].every((current, index) => current == bytes[index]);
    }
    Response.Header = ResponseHeader;
    Response.Like = ResponseLike;
})(Response || (Response = {}));
//# sourceMappingURL=index.js.map